:host {
  .module-loader {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &__img {
      max-width: 80px;
    }
  }

  .module-loader__img--1x {
    display: block;
  }
  .module-loader__img--2x {
    display: none;
  }

  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    .module-loader__img--1x {
      display: none;
    }
    .module-loader__img--2x {
      display: block;
    }
  }
}
